<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" @select="handleSelect" id="elMenu">
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/nansiIndex">首页</el-menu-item>
        <!-- <el-menu-item index="/nansi/gasClamp">全桥实时数据</el-menu-item> -->
        <el-submenu index="/nansi/steelBox">
          <template slot="title">钢箱梁</template>
          <el-menu-item index="/nansi/steelBox/NA12">NA12梁段钢箱梁除湿机</el-menu-item>
          <el-menu-item index="/nansi/steelBox/NJ09">NJ09梁段钢箱梁除湿机</el-menu-item>
          <el-menu-item index="/nansi/steelBox/NJ27">NJ27梁段钢箱梁除湿机</el-menu-item>
          <el-menu-item index="/nansi/steelBox/NJ44">NJ44梁段钢箱梁除湿机</el-menu-item>
          <el-menu-item index="/nansi/steelBox/SJ27">SJ27梁段钢箱梁除湿机</el-menu-item>
          <el-menu-item index="/nansi/steelBox/SJ09">SJ09梁段钢箱梁除湿机</el-menu-item>
          <el-menu-item index="/nansi/steelBox/SA12">SA12梁段钢箱梁除湿机</el-menu-item>
        </el-submenu>
        <el-submenu index="/nansi/tower">
          <template slot="title">鞍室</template>
          <el-menu-item index="/nansi/tower/Qixia">栖霞上游塔冠</el-menu-item>
          <el-menu-item index="/nansi/tower/Liuhe">六合上游塔冠</el-menu-item>
        </el-submenu>
        <el-submenu index="/nansi/stationFlow/SouthStation">
          <template slot="title">南制备站</template>
          <el-menu-item index="/nansi/stationFlow/SouthStation">南制备站送风</el-menu-item>
          <el-menu-item index="/nansi/stationSetting/SouthStation">南制备站设定</el-menu-item>
        </el-submenu>
        <el-submenu index="/nansi/stationFlow/MiddleStation">
          <template slot="title">中制备站</template>
          <el-menu-item index="/nansi/stationFlow/MiddleStation">中制备站送风</el-menu-item>
          <el-menu-item index="/nansi/stationSetting/MiddleStation">中制备站设定</el-menu-item>
        </el-submenu>
        <el-submenu index="/nansi/stationFlow/NorthStation">
          <template slot="title">北制备站</template>
          <el-menu-item index="/nansi/stationFlow/NorthStation">北制备站送风</el-menu-item>
          <el-menu-item index="/nansi/stationSetting/NorthStation">北制备站设定</el-menu-item>
        </el-submenu>

        <!-- <el-menu-item index="/sutong/bridgeImg">全桥除湿总体布置图</el-menu-item> -->
        <el-submenu index="/nansi/dataHistory?bridgeId=033d2279-bc46-40de-901e-f885acda440c&scenarioId=TBD">
          <template slot="title">数据历史</template>
          <el-menu-item index="/nansi/dataHistory?bridgeId=033d2279-bc46-40de-901e-f885acda440c&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/nansi/dataHistory?bridgeId=033d2279-bc46-40de-901e-f885acda440c"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="NANJING" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main su-tong">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "nansi",
  data() {
    return {
      bridgeId: "033d2279-bc46-40de-901e-f885acda440c",
      envInfo: {
        envId: "c9b8193e-2525-4c5c-9acf-5087ca3e0de3",
        weather: "11941a23-6a94-4456-b114-9cf091476dd9",
        humidity: "b02d6901-2593-4520-b742-b8e2f9227c91",
        temperature: "5f83975d-00e1-4f95-bfda-a0a961dc8c8a",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

     document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

 <style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;;
  display: none;
}
</style>